// import apis from '@/apis'
import * as axios from 'axios'
import Constants from '@/constants'

class Upload {
  static upload (formData) {
    const url = `${Constants.BASE_API}singulo/upload`
    return new Promise((resolve, reject) => {
      axios.post(url, formData)
        .then(x => x.data)
        .then(data => {
          // console.log('-- uploading.. --')
          // console.log(data)
          var index = 0
          for (var pair of formData.entries()) {
            // console.log('-- part --')
            // console.log(pair[0])
            // console.log(pair[1])
            if (data.files && index < data.files.length) {
              data.files[index].file = pair[1]
            }
            index += 1
          }
          // response:
          // files: [{filename: "20211116155515_d0c2mUCI1w_av-443066-1356999850.jpg", mime: "image/jpeg"}]
          // request: {attributes: {}, request: {}, query: {}, server: {}, files: {}, cookies: {}, headers: {}}
          // status: "ok"
          resolve(data)
        })
        .catch(error => reject(error))
    })
  }
}

export default Upload
